export default __webpack_public_path__ + "static/media/9.38ccc269.jpg";